import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/company/customer.company.link.mutation.gql"
import type {
  CustomerCompanyLinkMutation,
  CustomerCompanyLinkMutationVariables,
} from "@/v2-backoffice-client/customer/company/__types__/customer.company.link.mutation"

type Options = MutationHookOptions<
  CustomerCompanyLinkMutation,
  CustomerCompanyLinkMutationVariables
>

export function useCustomerCompanyLinkMutation(options?: Options) {
  return useMutation<
    CustomerCompanyLinkMutation,
    CustomerCompanyLinkMutationVariables
  >(mutation, options)
}
